__turbopack_context__.v({
  "description": "URLs-module-scss-module__5Gg3eW__description",
  "dropDownMenu": "URLs-module-scss-module__5Gg3eW__dropDownMenu",
  "icon": "URLs-module-scss-module__5Gg3eW__icon",
  "open": "URLs-module-scss-module__5Gg3eW__open",
  "urlDropDown": "URLs-module-scss-module__5Gg3eW__urlDropDown",
  "urlWrapper": "URLs-module-scss-module__5Gg3eW__urlWrapper",
  "urls": "URLs-module-scss-module__5Gg3eW__urls",
});
